import React from "react";
import { Box, Typography } from "@mui/material";

// Image Import
import DataNotFoundImg from './../../assets/images/not-found.svg';
import DataNotFoundImgDark from './../../assets/images/not-found-dark.svg';


interface DataNotFoundProps {
    title?: string;
    mode?: string;
}

const DataNotFound: React.FC<DataNotFoundProps> = ({ title = "No Record Found" ,mode="light"}) => {

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: mode == "light" ? "#fff" : "#3f3f3f" ,
            height: "100%"
        }}>
            <img src={mode == "light" ? DataNotFoundImg : DataNotFoundImgDark} alt={title} />
            <Typography fontWeight={400} color="#C8C8C8" fontSize={"18px"} marginTop={".8rem"}>{title}</Typography>
        </Box>
    )
};

export default DataNotFound;